import React from 'react';
import { useFeatureFlags } from '@tcc/shared-data-lib';
import { importFromS3 } from '../../utils/importFromS3';
import { useFeatureFlagsConfigs } from '../../utils/sharedData';
import { Operation } from '../../hooks/useOperations/types';

interface IProps {
  operations: Operation[];
  operationsSelected: string[];
}

const S3Plugin = React.lazy(() => importFromS3('dmb'));
const MFPlugin = React.lazy(() => import('dmbWeb/DmbWeb'));

export const DmbPluginContainer: React.FC<IProps> = ({ operations, operationsSelected }: IProps) => {
  const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs());
  const useModuleFederation = featureFlags?.['web.dmb.module-federation'];

  const DmbPlugin = useModuleFederation ? MFPlugin : S3Plugin;

  return (
    <DmbPlugin
      operations={operations}
      operationsSelected={operationsSelected}
    />
  );
};
